import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { FourSectionsLayoutMirror, FourSectionsLayoutMirrorComponent } from 'app/views/presentations/layouts/layouts/fourSectionsLayoutMirror/fourSectionsLayoutMirror.component';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(FourSectionsLayoutMirror)
    ],
    declarations: [
        FourSectionsLayoutMirrorComponent
    ],
    entryComponents: [
        FourSectionsLayoutMirrorComponent
    ]
})
export class FourSectionsLayoutMirrorModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/fourSectionsLayoutMirror/fourSectionsLayoutMirror.module.ts